export const OUR_TEAM_AUGMENTATION_SERVICES_DESKTOP_LIST = [
    {
        number: "01",
        header: "Blended teams",
        text: "We deeply analyze your needs and provide experts to your existing team. Our goal is to create a harmonious blend of talent and expertise, ensuring that you receive the most suitable team members to drive successful outcomes."
    },
    {
        number: "02",
        header: "Dedicated teams",
        text: "Our team of experts work under your supervision to develop your product. They can be assigned to separate modules of your project and take full responsibility for this part."
    },
    {
        number: "03",
        header: "Managed teams",
        text: "We take full responsibility for the technical side. Our executive team consists of a Technical Director who manages developers to meet your company goals. With a comprehensive understanding of your tech needs, we ensure efficient coordination and deliver high-quality results."
    }
]

export const OUR_TEAM_AUGMENTATION_SERVICES_MOBILE_LIST = [
    {
        number: "01",
        header: "Blended teams",
        text: "We deeply analyze your needs and provide experts to your existing team. Our goal is to create a harmonious blend of talent and expertise, ensuring that you receive the most suitable team members."
    },
    {
        number: "02",
        header: "Dedicated teams",
        text: "Our team of experts work under your supervision to develop your product. They can be assigned to separate modules of your project and take full responsibility for this part."
    },
    {
        number: "03",
        header: "Managed teams",
        text: "We take full responsibility for the technical side. Our executive team consists of a Technical Director who manages developers to meet your company goals."
    }
]

export const WHY_TEAM_AUGMENTATION_WITH_US = [
    {
        header: "Connected team & complex approach",
        text: "Our connected team works in a shared office space, employs innovative problem-solving techniques, prioritizes building strong relationships, and achieves exceptional results by leveraging the power of teamwork and effective communication.",
        mobile_text: "Our connected team and complex approach set us apart from freelancers, allowing us to deliver customized solutions and exceptional results for our clients. Trust us to bring your vision to life with our collaborative and comprehensive approach.",
        image: "https://newsoft-ns.com/media/team_augmentation/teamaugmentation1.webp"
    },
    {
        header: "Flexibility & scalability",
        text: "We are always ready to tackle complex challenges without bureaucracy. The team operates with flexibility and can adapt quickly to changing needs, delivering scalable solutions. With a focus on innovation and a willingness to take on challenging projects, our team achieves great success.",
        mobile_text: "We understand that every project has unique requirements, which is why Newsoft offers flexibility and scalability to accommodate your specific needs. With access to additional experts, we can deliver the solutions you need to achieve your goals.",
        image: "https://newsoft-ns.com/media/team_augmentation/teamaugmentation2.webp"
    }
]
